// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_speakersWrapper__INRgS {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid #6ba7a8;
  background-color: #fafafa;
  gap: 1rem;
  box-shadow: 1px 1px 8px 4px rgba(107, 167, 168, 0.1);
  overflow: hidden;
}
.styles_speakersWrapper__INRgS h3 {
  font-size: 20px;
  font-weight: 700;
  color: #6ba7a8;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 50vh;
  overflow-y: auto;
  position: relative;
  scrollbar-width: thin;
  scrollbar-color: #6ba7a8 #f1f1f1;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT::-webkit-scrollbar {
  width: 4px;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT::-webkit-scrollbar-thumb {
  background: #6ba7a8;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT s div:last-child {
  margin-bottom: 40px;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB {
  display: inline-flex;
  align-items: center;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB span {
  max-width: 870px;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media screen and (min-width: 992px) {
  .styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB span {
    max-width: 322px;
  }
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB input {
  display: inline-flex;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB input.styles_disabled__aEX66 {
  display: none;
}
.styles_speakersWrapper__INRgS .styles_speakerList__ZN8aT .styles_speaker__W5SfB .styles_image__N4eNa {
  width: 20px;
  height: auto;
  border-radius: 100%;
  margin-right: 8px;
}
.styles_speakersWrapper__INRgS .styles_editBtn__vpdJf {
  background-color: #6ba7a8;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: opacity 0.2s ease-in-out;
}
.styles_speakersWrapper__INRgS .styles_editBtn__vpdJf:hover {
  opacity: 0.8;
  cursor: pointer;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  flex-direction: column;
  gap: 8px;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_hiddenInput__G0uo4 {
  border-radius: 0.5em;
  border: 1px solid #7c7676;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_hiddenInput__G0uo4:focus {
  border-color: #6ba7a8;
  outline: none;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_addSpeaker__n6xI\\+ {
  background-color: #7c7676;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: opacity 0.2s ease-in-out;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_addSpeaker__n6xI\\+.styles_full__mHcaV {
  grid-column: span 2;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_addSpeaker__n6xI\\+:hover {
  opacity: 0.8;
  cursor: pointer;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_merge__SkNli {
  background-color: #7c7676;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: opacity 0.2s ease-in-out;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_merge__SkNli.styles_full__mHcaV {
  grid-column: span 2;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_merge__SkNli:hover {
  opacity: 0.8;
  cursor: pointer;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_actionButtons__uBFrm .styles_merge__SkNli:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_save__aDYpo {
  background-color: #6ba7a8;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: opacity 0.2s ease-in-out;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_save__aDYpo:hover {
  opacity: 0.8;
  cursor: pointer;
}
.styles_speakersWrapper__INRgS .styles_editing__X5tXn .styles_save__aDYpo:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/SpeakerList/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,SAAA;EACA,oDAAA;EACA,gBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAkBA,qBAAA;EACA,gCAAA;AAjBJ;AAAI;EACE,UAAA;AAEN;AACI;EACE,mBAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,gBAAA;AADN;AAMI;EACE,mBAAA;AAJN;AAOI;EACE,oBAAA;EACA,mBAAA;AALN;AAOM;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;AALR;AAMQ;EAJF;IAKI,gBAAA;EAHR;AACF;AAMM;EACE,oBAAA;AAJR;AAKQ;EACE,aAAA;AAHV;AAMM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAJR;AASE;EACE,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAPJ;AASI;EACE,YAAA;EACA,eAAA;AAPN;AAWE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AATJ;AAWI;EACE,aAAA;EACA,qCAAA;EACA,sBAAA;EACA,QAAA;AATN;AAWM;EACE,oBAAA;EACA,yBAAA;AATR;AAWQ;EACE,qBAAA;EACA,aAAA;AATV;AAaM;EACE,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAXR;AAaQ;EACE,mBAAA;AAXV;AAcQ;EACE,YAAA;EACA,eAAA;AAZV;AAeM;EACE,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAbR;AAeQ;EACE,mBAAA;AAbV;AAgBQ;EACE,YAAA;EACA,eAAA;AAdV;AAiBQ;EACE,YAAA;EACA,mBAAA;AAfV;AAmBI;EACE,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAjBN;AAmBM;EACE,YAAA;EACA,eAAA;AAjBR;AAoBM;EACE,YAAA;EACA,mBAAA;AAlBR","sourcesContent":[".speakersWrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 1px solid #6ba7a8;\n  background-color: #fafafa;\n  gap: 1rem;\n  box-shadow: 1px 1px 8px 4px rgba(107, 167, 168, 0.1);\n  overflow: hidden;\n\n  h3 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #6ba7a8;\n  }\n\n  .speakerList {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    max-height: 50vh;\n    overflow-y: auto;\n    position: relative;\n\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #6ba7a8;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: #ccc;\n    }\n\n    scrollbar-width: thin;\n    scrollbar-color: #6ba7a8 #f1f1f1;\n    s div:last-child {\n      margin-bottom: 40px;\n    }\n\n    .speaker {\n      display: inline-flex;\n      align-items: center;\n\n      span {\n        max-width: 870px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        @media screen and (min-width: 992px) {\n          max-width: 322px;\n        }\n      }\n\n      input {\n        display: inline-flex;\n        &.disabled {\n          display: none;\n        }\n      }\n      .image {\n        width: 20px;\n        height: auto;\n        border-radius: 100%;\n        margin-right: 8px;\n      }\n    }\n  }\n\n  .editBtn {\n    background-color: #6ba7a8;\n    border: 1px solid #fff;\n    color: #fff;\n    border-radius: 0.5rem;\n    padding: 0.5rem 1rem;\n    font-weight: 500;\n    transition: opacity 0.2s ease-in-out;\n\n    &:hover {\n      opacity: 0.8;\n      cursor: pointer;\n    }\n  }\n\n  .editing {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .actionButtons {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      flex-direction: column;\n      gap: 8px;\n\n      .hiddenInput {\n        border-radius: 0.5em;\n        border: 1px solid #7c7676;\n\n        &:focus {\n          border-color: #6ba7a8;\n          outline: none;\n        }\n      }\n\n      .addSpeaker {\n        background-color: #7c7676;\n        border: 1px solid #fff;\n        color: #fff;\n        border-radius: 0.5rem;\n        padding: 0.5rem 1rem;\n        font-weight: 500;\n        transition: opacity 0.2s ease-in-out;\n\n        &.full {\n          grid-column: span 2;\n        }\n\n        &:hover {\n          opacity: 0.8;\n          cursor: pointer;\n        }\n      }\n      .merge {\n        background-color: #7c7676;\n        border: 1px solid #fff;\n        color: #fff;\n        border-radius: 0.5rem;\n        padding: 0.5rem 1rem;\n        font-weight: 500;\n        transition: opacity 0.2s ease-in-out;\n\n        &.full {\n          grid-column: span 2;\n        }\n\n        &:hover {\n          opacity: 0.8;\n          cursor: pointer;\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n    }\n    .save {\n      background-color: #6ba7a8;\n      border: 1px solid #fff;\n      color: #fff;\n      border-radius: 0.5rem;\n      padding: 0.5rem 1rem;\n      font-weight: 500;\n      transition: opacity 0.2s ease-in-out;\n\n      &:hover {\n        opacity: 0.8;\n        cursor: pointer;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"speakersWrapper": `styles_speakersWrapper__INRgS`,
	"speakerList": `styles_speakerList__ZN8aT`,
	"speaker": `styles_speaker__W5SfB`,
	"disabled": `styles_disabled__aEX66`,
	"image": `styles_image__N4eNa`,
	"editBtn": `styles_editBtn__vpdJf`,
	"editing": `styles_editing__X5tXn`,
	"actionButtons": `styles_actionButtons__uBFrm`,
	"hiddenInput": `styles_hiddenInput__G0uo4`,
	"addSpeaker": `styles_addSpeaker__n6xI+`,
	"full": `styles_full__mHcaV`,
	"merge": `styles_merge__SkNli`,
	"save": `styles_save__aDYpo`
};
export default ___CSS_LOADER_EXPORT___;
